let messageIdCounter = 0;

export function getNextMessageId(): string {
  return `${Date.now()}-${++messageIdCounter}`;
}

export function resolveEndpoint(opts: {
  primary?: string | null;
  messageCreate?: string | null;
  message?: string | null;
  threadBase?: string | null;
  tid?: string | null;
  apiBaseUrl?: string | null;
}): string | null {
  if (opts.primary) return opts.primary;
  if (opts.messageCreate) return opts.messageCreate;
  if (opts.message) return opts.message;
  if (opts.threadBase && opts.tid) {
    const base = opts.threadBase.replace(/\/$/, '');
    return `${base}/${encodeURIComponent(opts.tid)}/messages`;
  }
  if (opts.apiBaseUrl) return `${opts.apiBaseUrl.replace(/\/$/, '')}/chat`;
  return null;
}
